// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hXiqR","footer":"styles_footer__2ZKgl","passCodeTooltip":"styles_passCodeTooltip__29jEj"};